import React from "react";
import "./GalleryPage.css";
import "./GalleryShared.css";



/* ── Hero Asset ── */
import gallaryherobanner from "../../Assets/Images/gallaryherobanner.png";
import Section2DAnimationNew from "./components/showcase/Section2DAnimationNew/Section2DAnimationNew";
import Section3DAnimationNew from "./components/showcase/Section3DAnimation/Section3DAnimationNew";
import Section3DVisualizationNew from "./components/showcase/Section3DVisualization/Section3DVisualizationNew";
import SectionVisualProductionNew from "./components/showcase/SectionVisualProduction/SectionVisualProductionNew";
import SectionBrandingDesignNew from "./components/showcase/SectionBrandingDesign/SectionBrandingDesignNew";
import SectionWebDesignNew from "./components/showcase/SectionWebDesign/SectionWebDesignNew";
import SectionGenerativeAINew from "./components/showcase/SectionGenerativeAINew/SectionGenerativeAInew";
import HeroCarousel from "./HeroCarousel";
import SectionExhibitionNew from "./components/showcase/SectionExhibitionNew/SectionExhibitionNew";
import SectionInteractive3DNew from "./components/showcase/SectionInteractive3DNew/SectionInteractive3DNew";
import SectionDigitalMarketingNew from "./components/showcase/SectionDigitalMarketingNew/SectionDigitalMarketingNew";
import SectionStrategyCTANew from "./components/showcase/SectionStrategyCTANew/SectionStrategyCTANew";

// Section view/dwell-time tracking - adjust this path if you placed the Client folder elsewhere
import SectionTracker from "../Client/SectionTracker";


/* ══════════════════════════════════════════════
   GALLERY PAGE
══════════════════════════════════════════════ */
export default function GalleryPage() {
  return (
    <div className="gallery-page">

      {/* ── Hero — stays in GalleryPage ── */}
      <section className="section-hero">
        <div className="gallary-hero-container">
          <h1 className="gallary-hero-title">
            Understanding Before Execution.
          </h1>
          <p className="gallary-hero-subtitle">
            Communication Built Around Business Objectives. Helping
            businesses communicate with greater clarity, consistency, and
            purpose.
          </p>
          <HeroCarousel />
          <p className="herotext">
            A portfolio shaped by diverse industries, structured execution,
            and communication aligned to business priorities.
          </p>
        </div>
      </section>

      {/* ── Sections ── */}
      <SectionTracker name="3d-animation">
        <Section3DAnimationNew />
      </SectionTracker>

      <SectionTracker name="2D Animation & Motion Graphics">
        <Section2DAnimationNew />
      </SectionTracker>

      <SectionTracker name="3d-visualization">
        <Section3DVisualizationNew />
      </SectionTracker>

      <SectionTracker name="interactive-3D">
        <SectionInteractive3DNew />
      </SectionTracker>

      <SectionTracker name="visual-production">
        <SectionVisualProductionNew />
      </SectionTracker>

      <SectionTracker name="branding-design">
        <SectionBrandingDesignNew />
      </SectionTracker>

      <SectionTracker name="web-design">
        <SectionWebDesignNew />
      </SectionTracker>

      <SectionTracker name="digital-marketing">
        <SectionDigitalMarketingNew />
      </SectionTracker>

      <SectionTracker name="AI-Powered Visual Communication">
        <SectionGenerativeAINew />
      </SectionTracker>

      {/* <SectionExhibitionNew/> */}

      <SectionTracker name="strategy-cta">
        <SectionStrategyCTANew />
      </SectionTracker>
    </div>
  );
}